
export function chiffre() {
  const animNum = (EL) => {
    if (EL._isAnimated) return;
    EL._isAnimated = true;

    $(EL)
      .prop('Counter', 0)
      .animate(
        {
          Counter: EL.dataset.num
        },
        {
          duration: 2000,
          step: function (now) {
            let text
            if (EL.dataset.num % 1 == 0) text = Math.ceil(now);
            else if ((EL.dataset.num * 10) % 1 == 0) text = now.toFixed(1);
            else text = now.toFixed(2);
            EL.innerHTML = numberWithSpaces(text);
          }
        }
      );
  };

  const inViewport = (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) animNum(entry.target);
    });
  };

  $('[data-num]').each((i, EL) => {
    const observer = new IntersectionObserver(inViewport);
    observer.observe(EL);
  });

  function numberWithSpaces(x) {
    let parts = x.toString().split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return parts.join('.');
  }
};
